import { useQuery } from "@tanstack/react-query";
import { useIdentity } from "../../auth/useIdentity";
import { isApplicantOnly, isSponsorOnly } from "../../components/nav";
import { getProviderKind } from "../../api/providerKind";

/**
 * The type of the provider the console is working in (identity.namespace), or
 * null when it is not known.
 *
 * 🔑 UNKNOWN MEANS THE FULL MENU, never the reduced one. A 404 (no profile),
 * a 403 or an unreachable gateway leaves the console exactly as it was before
 * this lookup existed; only a positive CLOUD_TENANT answer narrows it.
 */
export function useProviderKind(): string | null {
  const identity = useIdentity();
  const ns = identity.namespace ?? "";
  const q = useQuery({
    queryKey: ["provider-kind", ns],
    enabled: Boolean(identity.token && ns) && !isSponsorOnly(identity.roles) && !isApplicantOnly(identity.roles),
    queryFn: ({ signal }) => getProviderKind(identity, ns, signal),
    retry: false,
    staleTime: 5 * 60_000,
  });
  return q.data?.operatortype ?? null;
}
